import { partnerEvaluatedRiskColor, riskFlagStatusColor } from "@local/styles/muiTheme";

export const getStatusColor = (status) => partnerEvaluatedRiskColor[status];

export const getFlagStatusColor = (status) => riskFlagStatusColor[status];
